import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import Table                                  from '../../../../components/table/Table'
import {
    Checkbox, Switch, Slider, Col, Row, Table,
} from 'antd';
import { SFButton, SFCard } from '../../../../components/SF-UI';
import { firstLetterUpperCaseNoDashes, get } from '../../../../shared/helpers';
import { changeLeadOMRequest } from '../redux/actions/change_leadom_config.actions';
import { getLeadOMConfigRequest } from '../redux/actions/get_leadomatic_config.actions';

const mapStateToProps = (state) => {
    const { config, config_id } = state.PlatformManagement.Lead_o_matic_update;
    return { config, config_id };
};

export default connect(mapStateToProps, null)(class Configure extends Component {
    locationCriteriaTableColumns = [
        {
            title: 'Location',
            dataIndex: 'location',
            key: '1',
        },
        {
            title: 'Postcode',
            dataIndex: 'postcode',
            key: '2',
        },
        {
            title: 'Radius',
            dataIndex: 'radius',
            key: '3',
        },
        {
            title: 'Priority',
            dataIndex: 'priority',
            key: '4',
        },
        {
            title: 'Action',
            key: 'action',
            align: 'center',
            width: 70,
            render: record => (
                <Link to={this.props.leadomatic_update_access
                    ? { pathname: `/PlatformManagement/Lead-o-matic_update/location/edit/${record.id}` } : { pathname: '' }}
                >
                    {this.props.leadomatic_update_access ? 'Edit' : 'No Access'}
                </Link>
            ),
        },
    ]

    componentDidMount() {
        this.props.dispatch(getLeadOMConfigRequest());
    }

    changeSettings = (value, key) => this.props.dispatch(changeLeadOMRequest(this.props.config_id, { [key]: value }))

    changeSettingsRange = (target, key) => {
        const value = +target.getAttribute('aria-valuenow'); const
            { dispatch, config_id } = this.props;
        target.classList.contains('ant-slider-handle-1')
            ? dispatch(changeLeadOMRequest(config_id, { [`${key}.min`]: value }))
            : dispatch(changeLeadOMRequest(config_id, { [`${key}.max`]: value }));
    }

    transformLeadomaticConfigDataForTable = location_criteria => location_criteria.map(
        (location, index) => ({
            key: index,
            id: location._id,
            location: location.name,
            postcode: location.postcode,
            radius: location.radius,
            priority: location.priority,

        }),
    )

    render() {
        const { config, leadomatic_create_access } = this.props;

        let locationCriteriaDataForTable;
        if (config) locationCriteriaDataForTable = this.transformLeadomaticConfigDataForTable(config.location_criteria);

        return config
               && (
                   <Row>
                       <Col xs={24}>
                           <Switch
                               defaultChecked={get(config, 'use_leadomatic')}
                               onChange={value => this.changeSettings(value, 'use_leadomatic')}
                               size="default"
                               style={{ float: 'right', marginRight: 10, marginTop: -40 }}
                           />
                       </Col>
                       <Row gutter={50}>
                           <Col xs={24} xl={12} className="section">
                               <SFCard className="border-shadows">
                                   <h4>Bike Search Criteria</h4>
                                   <br />
                                   <div>
                                       <Fragment>
                                           <strong>Price Range</strong>
                                           <br />
                                           <Slider
                                               range
                                               onBlur={event => this.changeSettingsRange(event.target, 'bike_search_criteria.price_range')}
                                               min={0}
                                               max={20000}
                                               defaultValue={[config.bike_search_criteria ? config.bike_search_criteria.price_range.min : 0, config.bike_search_criteria ? config.bike_search_criteria.price_range.max : 0]}
                                               marks={{ 0: '£0', 20000: '£20000' }}
                                               tipFormatter={value => `£${value}`}
                                           />
                                       </Fragment>
                                       <Fragment>
                                           <strong>Mileage</strong>
                                           <br />
                                           <Slider
                                               min={config.bike_search_criteria ? config.bike_search_criteria.mileage.min : 0}
                                               max={50000}
                                               defaultValue={config.bike_search_criteria ? config.bike_search_criteria.mileage.max : 0}
                                               marks={{ 0: '0', 50000: '50000' }}
                                               onAfterChange={value => this.changeSettings(value, 'bike_search_criteria.mileage.max')}
                                           />
                                       </Fragment>
                                       <Fragment>
                                           <strong>Age</strong>
                                           <br />
                                           <Slider
                                               min={config.bike_search_criteria ? config.bike_search_criteria.age.min : 0}
                                               max={20}
                                               defaultValue={config.bike_search_criteria ? config.bike_search_criteria.age.max : 0}
                                               marks={{ 0: '0', 20: '20' }}
                                               onAfterChange={value => this.changeSettings(value, 'bike_search_criteria.age.max')}
                                           />
                                       </Fragment>
                                   </div>
                               </SFCard>
                           </Col>


                           <Col xs={24} xl={12} className="section">
                               <SFCard className="border-shadows">
                                   <h4>125cc Bike Search Criteria</h4>
                                   <br />
                                   <div className="form__form-group">
                                       <Fragment>
                                           <strong>Price Range</strong>
                                           <br />
                                           <Slider
                                               range
                                               min={0}
                                               max={20000}
                                               defaultValue={[config.scooter_search_criteria ? config.scooter_search_criteria.price_range.min : 0, config.scooter_search_criteria ? config.scooter_search_criteria.price_range.max : 0]}
                                               marks={{ 0: '£0', 20000: '£20000' }}
                                               onBlur={event => this.changeSettingsRange(event.target, 'scooter_search_criteria.price_range')}
                                               tipFormatter={value => `£${value}`}
                                           />
                                       </Fragment>
                                       <Fragment>
                                           <strong>Mileage</strong>
                                           <br />
                                           <Slider
                                               min={config.scooter_search_criteria ? config.scooter_search_criteria.mileage.min : 0}
                                               max={50000}
                                               defaultValue={config.scooter_search_criteria ? config.scooter_search_criteria.mileage.max : 0}
                                               marks={{ 0: '0', 50000: '50000' }}
                                               onAfterChange={value => this.changeSettings(value, 'scooter_search_criteria.mileage.max')}
                                           />
                                       </Fragment>
                                       <Fragment>
                                           <strong>Age</strong>
                                           <br />
                                           <Slider
                                               min={config.scooter_search_criteria ? config.scooter_search_criteria.age.min : 0}
                                               max={20}
                                               defaultValue={config.scooter_search_criteria ? config.scooter_search_criteria.age.max : 0}
                                               marks={{ 0: '0', 20: '20' }}
                                               onAfterChange={value => this.changeSettings(value, 'scooter_search_criteria.age.max')}
                                           />
                                       </Fragment>
                                   </div>
                               </SFCard>
                           </Col>
                       </Row>


                       <Col xs={24} className="section">
                           <SFCard className="border-shadows">
                               <div className="sf-btn-toolbar">
                                   {!leadomatic_create_access ? (
                                       <span style={{
                                           marginRight: 15, marginTop: 5, fontStyle: 'italic', color: 'red',
                                       }}
                                       >
                                           No Access Rights
                                       </span>
                                   ) : null}
                                   <SFButton type="primary" disabled={!leadomatic_create_access}>
                                       <Link to="/PlatformManagement/Lead-o-matic_update/location/add">Add New Location</Link>
                                   </SFButton>
                                   <br />
                                   <br />
                               </div>

                               {
                                   locationCriteriaDataForTable
                               && (
                                   <Table
                                       size="small"
                                       columns={this.locationCriteriaTableColumns}
                                       dataSource={locationCriteriaDataForTable}
                                       pagination={false}
                                   />
                               )
                               }
                           </SFCard>
                       </Col>
                       <Col xs={24} className="section">
                           <SFCard className="border-shadows">
                               <div style={{
                                   display: 'flex',
                                   justifyContent: 'space-between',
                               }}
                               >
                                   <div style={{ flexBasis: '45%' }}>
                                       <h4>Lead Priorities</h4>
                                       <br />
                                       <div style={{
                                           display: 'flex',
                                           justifyContent: 'space-between',
                                       }}
                                       >
                                           {
                                               config.priorities
                                                   ? Object.keys(config.priorities)
                                                       .map((priority) => {
                                                           if (priority === '_id') {
                                                               return undefined;
                                                           }
                                                           return (
                                                               <Checkbox
                                                                   defaultChecked={config.priorities[priority]}
                                                                   onChange={value => this.changeSettings(value.target.checked, `priorities.${priority}`)}
                                                                   key={priority}
                                                               >
                                                                   {priority}
                                                               </Checkbox>
                                                           );
                                                       })
                                                   : null
                                           }
                                       </div>
                                   </div>
                                   <div style={{ flexBasis: '45%' }}>
                                       <h4>Websites to Scrape</h4>
                                       <br />
                                       <div style={{
                                           display: 'flex',
                                           justifyContent: 'space-between',
                                       }}
                                       >
                                           {
                                               config.websites_to_scrape
                                                   ? Object.keys(config.websites_to_scrape)
                                                       .map((website) => {
                                                           if (website === '_id') {
                                                               return undefined;
                                                           }
                                                           return (
                                                               <Checkbox
                                                                   defaultChecked={config.websites_to_scrape[website]}
                                                                   onChange={value => this.changeSettings(value.target.checked, `websites_to_scrape.${website}`)}
                                                                   key={website}
                                                               >
                                                                   {firstLetterUpperCaseNoDashes(website)}
                                                               </Checkbox>
                                                           );
                                                       })
                                                   : null
                                           }

                                       </div>
                                   </div>
                               </div>
                           </SFCard>
                       </Col>
                   </Row>
               );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/components/LeadomaticConfigure.js